import { StockCustomItem, StockItem } from "./stock";

export class PriceTemplate {
    pricingTemplateId: number;
    pricingName: string;
    description: string;
}

export class PricingTemplate extends PriceTemplate {    
    clientId: number;    
    pricingMethod: number;
    pricingValue: number;
}

export class PricingRuleBase {
    pricingRuleId: number | null;
    pricingTemplateId: number | null;
    pricingMethod: number | null;
    pricingValue: number | null;
}

export class PricingRuleStockItem extends PricingRuleBase {
    tyreBrandId: number | null;
    msfId: number | null;
}

export class PricingRuleStockCustomItem extends PricingRuleBase {
    stockCustomId: number | null;
}

export class PricingTemplateStockItem extends StockItem {
    pricingRule: PricingRuleStockItem | null;
}

export class PricingTemplateStockCustomItem extends StockCustomItem {
    pricingRule: PricingRuleStockCustomItem | null;
}

export class PricingTemplateStockList {
    stockItems: PricingTemplateStockItem[];
    stockCustomItems: PricingTemplateStockCustomItem[];
}